// Copyright (c) 2022 by Move Closer

import { IRelatedService, ModuleContent } from '../../contexts'

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const abstractModuleContentResolver = async <Input extends ModuleContent, Output extends ModuleContent>
// eslint-disable-next-line @typescript-eslint/no-unused-vars
(input: Input, relatedService: IRelatedService): Promise<Input extends Output ? Input : unknown> => {
  return input as Input extends Output ? Input : unknown
}
